import * as actionTypes from '../actions/types';
import {GET_PROPERTY_DETAILS} from "../actions/types";

const initialState = {
    profile: null,
    profiles: [],
    repos: [],
    agents: [],
    sendConnection: [],
    sendConnectionLoader: false,
    rejectsConnection: [],
    rejectsConnectionLoader: false,
    acceptConnection: [],
    acceptConnectionLoader: false,
    removeConnectionLoader: false,
    connection: [],
    connectionLoader: false,
    loading: false,
    agentsLoader: false,
    agentSearchLoader: false,
    groupConversationListingLoader: false,
    groupConversationListing: [],
    reduxData: [],
    chatLists: [], // Chat List in the sidebar
    chatListsLoader: false,
    createGroupLoader: false,
    createGroup: [],
    updateGroupLoader: false,
    updateGroup: [],
    deleteGroupLoader: false,
    deleteGroup: [],
    roleLoader: false,
    role: [],
    singleRoleDetails: [],
    agentsByRoll: [],
    permissionLoader: false,
    permissions: [],
    error: {},
    totalConversation: 0,
    isNextAPICall:false,
};

function profileReducer(state = initialState, action) {
    const {type, payload} = action;

    switch (type) {
        case  actionTypes.GET_ROLE_LOADER:
            return {
                ...state,
                roleLoader: payload
            };
        case  actionTypes.GET_ROLE:
            return {
                ...state,
                role: payload
            };
        // GET SINGLE ROLE GET_PROPERTY_DETAILS
        case  actionTypes.GET_SINGLE_ROLE_DETAILS:
            return {
                ...state,
                singleRoleDetails: payload
            };
            // ADD UPDATE ROLE WISE PERMISSION
        case  actionTypes.ADD_UPDATE_ROLE:
            return {
                ...state,
                // role: payload
                role: state.role.map((data)=>data._id ===payload._id ?{
                    ...payload
                }:data)
            };
        case  actionTypes.GET_SINGLE_USER:
            return {
                ...state,
                singlUser: payload
            };
        case  actionTypes.UPDATE_SINGLE_USER_LOADER:
            return {
                ...state,
                updatesinglUserLoader: payload
            };
        case  actionTypes.UPDATE_SINGLE_USER:
            return {
                ...state,
                agentsByRoll: state.agentsByRoll.map(data => (data._id === payload._id) ? {
                    ...data,
                    payload
                } : data)
            };
        case  actionTypes.DELETE_SINGLE_USER_LOADER:
            return {
                ...state,
                deletesinglUserLoader: payload
            };
        case  actionTypes.DELETE_SINGLE_USER:
            return {
                ...state, agentsByRoll: [...state.agentsByRoll.filter(u => u._id !== action.payload)]
            };
        case actionTypes.GET_PROFILE:
        case actionTypes.UPDATE_PROFILE:
            return {
                ...state,
                profile: payload,
                loading: true
            };
        case actionTypes.GET_PROFILES:
            return {
                ...state,
                profiles: payload,
                loading: true
            };
        case actionTypes.PROFILE_ERROR:
            return {
                ...state,
                error: payload,
                loading: true,
                profile: null
            };
        case actionTypes.CLEAR_PROFILE:
            return {
                ...state,
                profile: null,
                repos: []
            };
        case actionTypes.GET_REPOS:
            return {
                ...state,
                repos: payload,
                loading: true
            };
        case actionTypes.NO_REPOS:
            return {
                ...state,
                repos: []
            };
        case actionTypes.AGENT_LISTING:
            return {
                ...state,
                agents: payload,
                //isAuthenticated: true,
                loading: true
            };
        case actionTypes.AGENT_LISTING_LOADER:
            return {
                ...state,
                agentsLoader: payload,
            };
        case actionTypes.SEND_CONNECTION_REQUEST_LOADER:
            return {
                ...state,
                sendConnectionLoader: payload,
            };
        case actionTypes.REJECT_CONNECTION_REQUEST_LOADER:
            return {
                ...state,
                rejectsConnectionLoader: payload,
            };
        case actionTypes.ACCEPT_CONNECTION_REQUEST_LOADER:
            return {
                ...state,
                acceptConnectionLoader: payload,
            };
        case actionTypes.REMOVE_FRIEND_CONNECTION_REQUEST_LOADER:
            return {
                ...state,
                removeConnectionLoader: payload,
            };
        case actionTypes.REMOVE_AGENTS:
            return {
                ...state,
                agents: payload,
            };
        case  actionTypes.GET_AGENTS:
            return {
                ...state,
                agents: [...state.agents, ...payload],
                loading: true
            };
        case  actionTypes.GET_AGENTS_BY_ROLE:
            return {
                ...state,
                agentsByRoll: payload,
                loading: true
            };
        case  actionTypes.GET_AGENTS_LOADING:
            return {
                ...state,
                agentSearchLoader: payload
            };
        case  actionTypes.CONNECTION_LISTING:
            return {
                ...state,
                connection: payload,
                loading: true
            };
        case  actionTypes.CONNECTION_LISTING_LOADER:
            return {
                ...state,
                connectionLoader: payload
            };
        case  actionTypes.CREATE_GROUP_LISTING:
            return {
                ...state,
                createGroup: payload,
                chatLists: [...state.chatLists, payload],
                loading: true
            };
        case  actionTypes.CREATE_GROUP_LOADER:
            return {
                ...state,
                createGroupLoader: payload
            };
        case  actionTypes.UPDATE_GROUP_LISTING:
            return {
                ...state,
                chatLists: [...state.chatLists, payload],
                updateGroup: payload,
                loading: true
            };
        case  actionTypes.UPDATE_GROUP_LISTING_BACKEND:
            return {
                ...state,
                chatLists: [...state.chatLists.map(u => u._id === action.payload._id && {
                    ...u,
                    status:payload.status
                })],
            };
        case  actionTypes.EXIT_GROUP_LISTING:
            return {
                ...state, chatLists: [...state.chatLists.filter(u => u._id !== action.payload)]
            };
            case  actionTypes.DELETE_GROUP_LISTING:
            return {
                ...state, chatLists: [...state.chatLists.filter(u => u._id !== action.payload)]
            };

        case  actionTypes.UPDATE_GROUP_LOADER:
            return {
                ...state,
                updateGroupLoader: payload
            };
        case  actionTypes.DELETE_GROUP_LOADER:
            return {
                ...state,
                deleteGroupLoader: payload
            };
        case  actionTypes.GROUP_LISTING:
            return {
                ...state,
                chatLists: payload,
                loading: true
            };
        case  actionTypes.GROUP_LISTING_LOADER:
            return {
                ...state,
                chatListsLoader: payload
            };
        case  actionTypes.GROUP_CONVERSATION_LISTING_LOADER:
            return {
                ...state,
                groupConversationListingLoader: payload
            };
        case  actionTypes.NEXT_GROUP_CONVERSATION_API_CALL:
            return {
                ...state,
                isNextAPICall: payload
            };
        case  actionTypes.GROUP_CONVERSATION_LISTING:
            return {
                ...state,
                chatLists: state.chatLists.map(chatUser => (chatUser._id === payload.receiverID && payload.conversation) ? ({
                    ...chatUser,
                    // conversation:chatUser.conversation.concat(payload.conversation),
                    conversation:payload.conversation.concat(chatUser.conversation)
                    // conversation:payload.conversation
                }) : chatUser)
            };
        case  actionTypes.FIRTS_TIME_GROUP_CONVERSATION_LISTING:
            return {
                ...state,
                chatLists: state.chatLists.map(chatUser => (chatUser._id === payload.receiverID && payload.conversation) ? ({
                    ...chatUser,
                    // conversation:chatUser.conversation.concat(payload.conversation),
                    // conversation:payload.conversation.concat(chatUser.conversation)
                    conversation:payload.conversation
                }) : chatUser)
            };
        // case  actionTypes.REMOVE_GROUP_CONVERSATION_LISTING:
        //     return {
        //         ...state,
        //         chatLists: payload
        //     };
        // case  actionTypes.APPEND_CHAT_MESSAGE:
        //     return {
        //         ...state,
        //         groupConversationListing: [...state.groupConversationListing, payload.messageData]
        //         //groupConversationListing: state.groupConversationListing.map(data=>(((data.user && data.user) || (data.group && data.group)) === payload.id))&&[...state.groupConversationListing, payload.messageData],
        //
        //     };
        case  actionTypes.APPEND_CHAT_MESSAGE:
            return {
                ...state,
                // chatLists: state.chatLists.map(chatUser => (payload.chat_token.includes(chatUser._id) && payload.chat_token.includes(chatUser.type)) ? ({
                chatLists: state.chatLists.map(chatUser => ((payload.chat_token.split('~')[0]===chatUser._id) && (payload.chat_token.split('~')[1]===chatUser.type)) ? ({
                    ...chatUser,
                    last_message:payload,
                    last_message_time:payload.updatedAt,
                    conversation:[...chatUser.conversation,payload]
                }) : chatUser)

            };
        case  actionTypes.APPEND_RECEIVER_CHAT_MESSAGE:
            return {
                ...state,
                // chatLists: state.chatLists.map(chatUser => (payload.chat_token.includes(chatUser._id) && payload.chat_token.includes(chatUser.type)) ? ({
                chatLists: state.chatLists.map(chatUser => ((payload.receiver_token.split('~')[0]===chatUser._id) && (payload.receiver_token.split('~')[1]===chatUser.type)) ? ({
                    ...chatUser,
                    last_message:payload,
                    last_message_time:payload.updatedAt,
                    conversation:[...chatUser.conversation,payload]
                }) : chatUser)

            };
        case  actionTypes.APPEND_LAST_CHAT_MESSAGE:
            return {
                ...state,
                chatLists: state.chatLists.map(chatUser => (payload.chat_token.includes(chatUser._id) && payload.chat_token.includes(chatUser.type)) ? ({
                    ...chatUser,
                    last_message:payload,
                    last_message_time:payload.updatedAt,
                    is_new_massage:true,
                    // conversation:[...chatUser.conversation,payload]
                }) : chatUser)

            };

        case  actionTypes.SET_CHAT_DATA_REDUX:
            return {
                ...state,
                reduxData: payload
            };
        case  actionTypes.SET_ONLINE_DATA_REDUX:
            return {
                ...state,
                //redux data
                reduxData: {...state.reduxData, is_online: payload.is_online, last_seen: payload.last_seen},
                //props data
                chatLists: state.chatLists.map(group => (group._id === payload._id) ? {
                    ...group,
                    is_online: payload.is_online
                } : group),
            };
        case  actionTypes.GROUP_MESSAGE:
            return {
                ...state,
                chatLists: state.chatLists.map(group => (group._id === payload._id) ? {
                    ...group,
                    name: payload.name,
                    image: payload.image
                } : group),
            };

        case  actionTypes.SET_TOTAL_CONVERSATION_COUNT:
            return {
                ...state,
                totalConversation: payload,
            };



        // GET ALL PERMISSION
        case  actionTypes.GET_PERMISSION_LOADER:
            return {
                ...state,
                permissionLoader: payload,
            };
        case  actionTypes.GET_PERMISSIONS:
            return {
                ...state,
                permissions: payload,
            };


        default:
            return state;
    }
}

export default profileReducer;
